import { gql } from "apollo-boost";

export const GET_AVAILABLE_SUBSCRIPTION_VEHICLES = gql`
  query getConsumerSubscriptionCatalogue($bookingId: String) {
    getConsumerSubscriptionCatalogue(bookingId: $bookingId) {
      id
      bodyType
      make
      model
      year
      licencePlate
      numberOfDoors
      numberOfSeats
      transmission
      fuelType
      imageUrl
      colour
      features
      co2Emissions
      tankCapacity
      interiorColour
      subscriptions {
        deposit
        subscription {
          isActive
          id
          name
          rateTypeName
          addons {
            id
            name
            displayName
            description
            category
            hasFixedRate
            fixedRate
            recurringRate {
              rateTypeName
              rate
              rateTypeDuration
              longTerm
            }
          }
          insurancePolicy {
            id
            name
            description
          }
        }
        pricings {
          duration
          enrollmentAmount
          mileage
          subscriptionAmount
          pricePerExtraMile
          unlimitedMileage
          swapsAllowed
        }
      }
      availableFrom
      branchId
      currentServiceLocation {
        id
        isDisabled
      }
      interiorFeatures
      exteriorFeatures
      safetyAndTechnicalFeatures
    }
  }
`;
